export class KioskClientSecretsResponse {

}